export default {"src":"/_next/static/media/earn-step-1.920978ee.svg","height":752,"width":980,"blurWidth":0,"blurHeight":0};